"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = interpolateDefaultRequire;

// https://medium.com/webpack/webpack-4-import-and-commonjs-d619d626b655
function interpolateDefaultRequire(m) {
  try {
    return m && m.default ? m.default : m;
  } catch (e) {
    return m;
  }
}